import _ from 'lodash'
// import { clearTimeout } from 'timers'

export default {
  create: ({commit, state}, payload) => {
    return new Promise((resolve, reject) => {
      let item = _.extend({},
        {
          id: state.items.length
        }, payload)
      commit('create', item)
      resolve(item.id)
    })
  },
  initialize: ({commit, state, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit('setInitialized', true)
      resolve(state.initialized)
      // dispatch('scrolltopanel', 0).then(() => {
        
      // })
    })
  },
  increment: ({dispatch, state}, direction) => {
    return new Promise((resolve, reject) => {
      let next = (direction === 1) ? (state.active + 1) : (direction === 0) ? (state.active - 1) : false
      // if next is greater than the max allowed then set to last item
      // if next is less than 0 set to 0
      if (next > state.items.length - 1) {
        next = state.items.length - 1
      } else if (next < 0) {
        next = 0
      }
      dispatch('activate', next).then(() => {
        resolve()
      })
    })
  },
  // activate: ({commit, state, dispatch}, id) => {
  //   return new Promise((resolve, reject) => {
  //     if (state.animating || state.pause || !state.scrolltocomplete) return
  //     dispatch('scrolltopanel', id).then(() => {
  //       commit('setAnimating', true)
  //       commit('setPause', true)
  //       commit('setFirstActive', id === 0)
  //       commit('setLastActive', id === state.items.length - 1)
  //       commit('setPrevious', state.active)
  //       commit('setActive', id)
  //       let r = resolve
  //       let timer = setTimeout(function () {
  //         commit('setAnimating', false)
  //         commit('setPrevious', null)
  //         clearTimeout(timer)
  //         r(state.active)
  //       }, state.speed + 1)
  //     })
  //   })
  // },
  activate: ({commit, state, dispatch}, id) => {
    return new Promise((resolve, reject) => {
      commit('addActive', id)
      let active = _.maxBy(state.activepanels, function (p) {
        return p
      })
      commit('setActive', active)
      commit('setFirstActive', state.active === 0)
      commit('setLastActive', state.active === state.items.length - 1)
    })
  },
  deactivate: ({commit, state, dispatch}, id) => {
    return new Promise((resolve, reject) => {
      commit('removeActive', id)
      let active = _.maxBy(state.activepanels, function (p) {
        return p
      })
      commit('setActive', active)
      commit('setFirstActive', state.active === 0)
      commit('setLastActive', state.active === state.items.length - 1)
      // commit('setActive', id)
      // commit('setFirstActive', id === 0)
      // commit('setLastActive', id === state.items.length - 1)
    })
  },
  scrolltopanel: ({commit, state, dispatch}, id) => {
    commit('scrollToPanel', id)
    // return new Promise((resolve, reject) => {
    //   dispatch('scrolltocomplete', false).then(() => {
    //     let timer = setTimeout(function () {
    //       dispatch('scrolltocomplete', true).then(() => {
    //         clearTimeout(timer)
    //         resolve(id)
    //       })
    //     }, 100)
    //   })
    // })
  }
  // scrolltopanel: ({commit, state, dispatch}, id) => {
  //   commit('scrollToPanel', id)
  //   return new Promise((resolve, reject) => {
  //     dispatch('scrolltocomplete', false).then(() => {
  //       let timer = setTimeout(function () {
  //         dispatch('scrolltocomplete', true).then(() => {
  //           clearTimeout(timer)
  //           resolve(id)
  //         })
  //       }, 100)
  //     })
  //   })
  // },
  // scrolltocomplete: ({commit, state}, which) => {
  //   return new Promise((resolve, reject) => {
  //     commit('setScrollToComplete', which)
  //     resolve(state.scrolltocomplete)
  //   })
  // }
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/panels/actions.js